'use strict';

/** This controls rendering of a quiz section.
    If a quiz has more than 1 question, it renders in a modal. Otherwise it renders inline.
**/

angular.module('msWidgets').directive('msWidgetToolsQuiz', [function () {
  return {
    templateUrl: 'widgets/templates/tools/quiz.html',
    controller: WidgetToolsQuizController
  };
}]);

WidgetToolsQuizController.$inject = ['$scope', 'NotifyingSvc', '$translate', '$log', '$timeout'];

function WidgetToolsQuizController($scope, NotifyingSvc, $translate, $log, $timeout) {
  $scope.openQuizModal = openQuizModal;
  activate();

  function activate() {
    $log.debug('msWidgetToolsQuizController activate');
    $scope.quizSection = findSection($scope.widget.properties['section']);
    //get default or custom label for the quiz, used for both inline and modal versions
    //note the use of $translate.instant
    $scope.quizLabel = $scope.widget.properties.label;
    $log.debug($scope.quizSection);
  }

  function openQuizModal() {
    NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
      templateUrl: 'activities/templates/quiz-modal.html',
      controller: 'ActivityQuizModalCtrl',
      inputs: {
        quiz: $scope.quizSection,
        quizLabel: $scope.quizLabel
      },
      closeCallback: modalCallback
    });
  }

  function modalCallback(save) {
    if (save) {
      // Give the modal time to close, wait 300ms + 20ms just to be safe.
      $timeout(function () {
        $scope.quizNext();
      }, 320);
    }
  }

  function findSection(uuid) {
    return $scope.activityVm.activity.sections.filter(function (section) {
      return section.uuid === uuid;
    })[0];
  }
}